import React from 'react'

import newProject_getMyTemplates from "../helper/get-my-templates"
import {NewProject_SelectedType} from "../new-project-main"
import {QuickAddBreadcrumbElement, QuickAddItemType} from "../../../@types"
import QuickAdd_SelectTypeWithBreadcrumbs from "../../../common/select-type/select-type-with-breadcrumbs"
import {BreadcrumbElement} from "../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"

type Props = {
    onSelectType    : {(type: any, templateId: ID): void}
}

// const debug = "NewProject_SelectTemplate"
const debug = false

export default function NewProject_SelectTemplate(props: Props) {

    const onHelpProjectTypes = () => {
        gd.openInNewWindow(gd.utils.helpUrl('customization.project_types'))
    }

    const onManageProjectTypes = () => {
        gd.goTo('settings/templates')
    }

    const myTemplates = newProject_getMyTemplates()

    let typeItems = [
        {
            title       : 'Resources',
            items       : [
                {
                    typeId      : "folder",
                    svgIcon50   : 'isvg-folder',
                    title       : 'Folder',
                    description : 'Container for organizing and grouping related projects or tasks.',
                    onClick     : ()=>{gd.openNew(QuickAddItemType.FOLDER)}
                },
                {
                    typeId      : "page",
                    svgIcon50   : 'isvg-page',
                    title       : 'Document',
                    description : 'A flexible document for organizing notes or information.',
                    onClick     : ()=>{gd.openNew(QuickAddItemType.PAGE)}
                },
            ]
        },
        {
            title       : 'Projects',
            items       : [
                ...myTemplates,
                {
                    typeId      : NewProject_SelectedType.SELECT_TEMPLATE_FROM_LIBRARY,
                    svgIcon50   : 'isvg-templates',
                    title       : 'Template Library',
                    description : 'Explore and apply templates to set up projects faster.'
                },
            ]
        },
        /*{
            title       : 'Workspace',
            items       : [
                {
                    typeId      : "workspace",
                    svgIcon50   : 'isvg-workspace',
                    title       : 'Workspace',
                    description : 'Separate space with its own projects, tasks, and settings.',
                    onClick     : ()=>{gd.openNew(QuickAddItemType.WORKSPACE)}
                },
            ]
        },*/
    ]

    const isManager = gd.ac.check.company.isManager()

    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.PROJECT_RESOURCES,
    ]

    return (
        <div className="new-main project select-my-templates">
            <QuickAdd_SelectTypeWithBreadcrumbs breadcrumbItems = {breadcrumbItems}
                                                typeItems       = {typeItems}
                                                onSelectType    = {props.onSelectType}/>

            {isManager &&
                <div className="bottom-panel">
                        <div className="bottom-panel-link" onClick={onManageProjectTypes}>
                            <div className="link-icon i5-wrench"/>
                            <div className="link-title">Manage templates</div>
                        </div>
                </div>}

            {/*<div className="bottom-panel">
                {isManager &&
                    <div className="bottom-panel-link" onClick={onManageProjectTypes}>
                        <div className="link-icon i5-wrench"/>
                        <div className="link-title">Manage templates</div>
                    </div>}

                <div className="bottom-panel-link" onClick={onHelpProjectTypes}>
                    <div className="link-icon i5-question-circle"/>
                    <div className="link-title">Help</div>
                </div>
            </div>*/}
        </div>
    )
}
